// hooks/usePipelineSteps.js
import { useEffect, useState } from 'react';
import yaml from 'js-yaml';

function topoSort(nodes = [], deps = {}) {
  const inDeg = Object.fromEntries(nodes.map(n => [n, 0]));
  const graph = Object.fromEntries(nodes.map(n => [n, []]));
  nodes.forEach(n => {
    (deps[n] || []).forEach(d => {
      if (nodes.includes(d)) {
        graph[d].push(n);
        inDeg[n]++;
      }
    });
  });

  const queue = nodes.filter(n => inDeg[n] === 0);
  const order = [];
  while (queue.length) {
    const n = queue.shift();
    order.push(n);
    graph[n].forEach(m => {
      if (--inDeg[m] === 0) queue.push(m);
    });
  }

  return order.length === nodes.length ? order : nodes;
}

export function parsePipelineYaml(yamlString = '') {
  try {
    const cleaned = yamlString.replace(/!Ref\s+(\S+)/g, '$1');
    const doc = yaml.load(cleaned) || {};
    const dataSrcs = Object.keys(doc.data_sources || {});
    const exporters = Object.keys(doc.exporters || {});
    const pipeName = Object.keys(doc.pipelines || {})[0];
    if (!pipeName) return { stepKeys: [], dataSrcs, filters: {}, exporters, sortedFilters: [] };

    const filters = doc.pipelines[pipeName].filters || {};
    const filterIds = Object.keys(filters);
    const depsMap = filterIds.reduce((acc, k) => {
      acc[k] = filters[k].depends_on || [];
      return acc;
    }, {});
    const sorted = topoSort(filterIds, depsMap);

    return {
      stepKeys: [...dataSrcs, ...sorted, ...exporters],
      dataSrcs,
      filters,
      exporters,
      sortedFilters: sorted,
    };
  } catch (err) {
    console.error('YAML parse failed:', err);
    return { stepKeys: [], dataSrcs: [], filters: {}, exporters: [], sortedFilters: [] };
  }
}

export default function usePipelineSteps(yamlString) {
  const [parsed, setParsed] = useState(() => parsePipelineYaml(yamlString));

  useEffect(() => {
    setParsed(parsePipelineYaml(yamlString));
  }, [yamlString]);

  return parsed;
}
